import { Routes } from './routes';

import './style/global.css';

function App() {
  return <Routes />;
}

export default App;
